import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "row mb-6" }
const _hoisted_2 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_3 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_4 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_5 = { class: "form-check-label fw-bold text-gray-700" }
const _hoisted_6 = { class: "offset-lg-4 col-lg-8 form-text" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_8 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_9 = { class: "row mb-6" }
const _hoisted_10 = { class: "offset-lg-4 col-lg-8" }
const _hoisted_11 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_12 = { class: "form-check-label fw-bold text-gray-700" }
const _hoisted_13 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_14 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_15 = { class: "col-lg-8 fv-row" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "row mb-6" }
const _hoisted_20 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_21 = { class: "col-lg-8 fv-row" }
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = ["onUpdate:modelValue", "inputmode"]
const _hoisted_26 = {
  key: 3,
  class: "form-text"
}
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = {
  key: 0,
  class: "text-muted mb-6"
}
const _hoisted_30 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_31 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_32 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "form-check-label fw-bold" }
const _hoisted_35 = {
  key: 3,
  class: "row mb-6"
}
const _hoisted_36 = { class: "offset-lg-4 col-lg-8" }
const _hoisted_37 = { class: "input-group" }
const _hoisted_38 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.translate('bannerDeeplinkTitle')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enabled) = $event)),
            class: "form-check-input",
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, _ctx.enabled]
          ]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.translate('bannerDeeplinkEnable')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.translate('bannerDeeplinkHint')), 1)
    ]),
    (_ctx.enabled && _ctx.forbidden)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.translate('bannerDeeplinkNoPermission')), 1))
      : (_ctx.enabled)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.destinationsError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.destinationsError) + " ", 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-light-danger ms-3",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadDestinations && _ctx.loadDestinations(...args)))
                  }, _toDisplayString(_ctx.translate('deeplinkRetry')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.advanced) = $event)),
                    class: "form-check-input",
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.advanced]
                  ]),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.translate('deeplinkAdvanced')), 1)
                ])
              ])
            ]),
            (_ctx.advanced)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.translate('deeplinkPasteLink')), 1),
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rawDeeplink) = $event)),
                      type: "text",
                      dir: "ltr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: `${_ctx.DEEPLINK_BASE}?url=ads-list&lang=ar`
                    }, null, 8, _hoisted_16), [
                      [_vModelText, _ctx.rawDeeplink]
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.shownErrors.rawDeeplink), 1)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.translate('bannerDeeplinkScreen')), 1),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.destination,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.destination) = $event)),
                        class: "w-100",
                        filterable: "",
                        clearable: "",
                        loading: _ctx.destinationsLoading,
                        placeholder: _ctx.translate('deeplinkSelectType')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.destinations, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.destination,
                              label: _ctx.screenLabel(item),
                              value: item.destination
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading", "placeholder"]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.shownErrors.destination), 1)
                      ])
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentParams, (param) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${_ctx.destination}-${param.key}`,
                      class: "row mb-6"
                    }, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["col-lg-4 col-form-label fw-bold fs-6", { required: param.required }])
                      }, _toDisplayString(_ctx.paramLabel(param.key)), 3),
                      _createElementVNode("div", _hoisted_24, [
                        (
              param.spec.input === 'select' ||
              param.spec.input === 'multiselect' ||
              param.spec.input === 'auction'
            )
                          ? (_openBlock(), _createBlock(_component_el_select, {
                              key: 0,
                              modelValue: _ctx.params[param.key],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.params[param.key]) = $event),
                              class: "w-100",
                              filterable: "",
                              clearable: "",
                              multiple: param.spec.input === 'multiselect',
                              "allow-create": param.spec.input === 'auction',
                              "default-first-option": param.spec.input === 'auction',
                              loading: _ctx.isLookupLoading(param.spec),
                              disabled: _ctx.isWaitingOnParent(param.spec),
                              placeholder: 
              _ctx.selectPlaceholder(
                param.spec,
                param.spec.input === 'multiselect'
                  ? 'deeplinkSelectMany'
                  : param.spec.input === 'auction'
                  ? 'deeplinkAuctionPlaceholder'
                  : 'deeplinkSelectPlaceholder'
              )
            
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramOptions(param.spec), (option) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: option.value,
                                    label: option.label,
                                    value: option.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "multiple", "allow-create", "default-first-option", "loading", "disabled", "placeholder"]))
                          : (
              param.spec.input === 'date' || param.spec.input === 'month'
            )
                            ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                key: 1,
                                modelValue: _ctx.params[param.key],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.params[param.key]) = $event),
                                class: "w-100",
                                type: param.spec.input,
                                format: param.spec.input === 'date' ? 'YYYY-MM-DD' : 'YYYY-MM',
                                "value-format": 
              param.spec.input === 'date' ? 'YYYY-MM-DD' : 'YYYY-MM'
            ,
                                placeholder: 
              _ctx.translate(
                param.spec.input === 'date'
                  ? 'deeplinkDatePlaceholder'
                  : 'deeplinkMonthPlaceholder'
              )
            
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "format", "value-format", "placeholder"]))
                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 2,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.params[param.key]) = $event),
                                type: "text",
                                dir: "ltr",
                                autocomplete: "off",
                                class: "form-control form-control-lg form-control-solid",
                                inputmode: param.spec.input === 'number' ? 'numeric' : 'text'
                              }, null, 8, _hoisted_25)), [
                                [_vModelText, _ctx.params[param.key]]
                              ]),
                        (_ctx.destination === 'cce' && param.key === 'id')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.translate('deeplinkCceHint')), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.shownErrors[param.key]), 1)
                        ])
                      ])
                    ]))
                  }), 128)),
                  (_ctx.selectedDestination && !_ctx.currentParams.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.translate('deeplinkNoParams')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.destination)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.translate('deeplinkLang')), 1),
                        _createElementVNode("div", _hoisted_32, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['ar', 'en'], (item) => {
                            return _createElementVNode("label", {
                              key: item,
                              class: "form-check form-check-custom form-check-solid me-10"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.lang) = $event)),
                                class: "form-check-input",
                                type: "radio",
                                value: item
                              }, null, 8, _hoisted_33), [
                                [_vModelRadio, _ctx.lang]
                              ]),
                              _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.translate(item === 'ar' ? 'deeplinkLangAr' : 'deeplinkLangEn')), 1)
                            ])
                          }), 64))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64)),
            (_ctx.deeplink)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("input", {
                        type: "text",
                        readonly: "",
                        dir: "ltr",
                        class: "form-control form-control-lg form-control-solid",
                        value: _ctx.deeplink
                      }, null, 8, _hoisted_38),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-light-primary",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.copyDeeplink && _ctx.copyDeeplink(...args)))
                      }, _toDisplayString(_ctx.translate(_ctx.copied ? 'deeplinkCopied' : 'deeplinkCopy')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-light",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
                      }, _toDisplayString(_ctx.translate('deeplinkClear')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
  ], 64))
}